export async function cachedFetchAPI(url:string) {
	if (localStorage.getItem(`cached-${url}`)) {
		return JSON.parse(localStorage.getItem(`cached-${url}`)!);
	}
	let data = await fetch(url);
	let json = await data.json();
	if (data.status === 200) localStorage.setItem(`cached-${url}`, JSON.stringify(json));
	return json;
}